import _typeof from "@babel/runtime/helpers/esm/typeof";

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 13:55:40
 * @LastEditTime: 2021-03-03 16:51:01
 */
export var getParamType = function getParamType(obj) {
  return obj == null ? String(obj) : Object.prototype.toString.call(obj).replace(/\[object\s+(\w+)\]/i, '$1') || 'object';
};
export var extend = function extend(destination, source) {
  if (destination == null) {
    destination = source;
  } else {
    for (var property in source) {
      if (getParamType(source[property]).toLowerCase() === 'object' && getParamType(destination[property]).toLowerCase() === 'object') extend(destination[property], source[property]);else destination[property] = source[property];
    }
  }

  return destination;
};
/**
 * 判断对象是否定义
 * 其实只对对象中的元素判断有效，如是纯变量，此方法会无法调用，需要外面加try
 * @param {object} object 对象
 * @return {bool} 是/否
 */

export var isUndefined = function isUndefined(o) {
  return o === undefined && typeof o === 'undefined';
};
/**
 * 判断对象是否数组
 * @param {object} object 对象
 * @return {bool} 是/否
 */

export var isArray = function isArray(obj) {
  return getParamType(obj).toLowerCase() === 'array';
};
/**
 * 判断对象是否函数
 * @param {object} object 对象
 * @return {bool} 是/否
 */

export var isFunction = function isFunction(obj) {
  return getParamType(obj).toLowerCase() === 'function';
};
/**
 * 判断对象是否对象
 * @param {object} object 对象
 * @return {bool} 是/否
 */

export var isObject = function isObject(obj) {
  return getParamType(obj).toLowerCase() === 'object';
};
/**
 * 判断对象是否数值
 * @param {object} object 对象
 * @return {bool} 是/否
 */

export var isNumber = function isNumber(obj) {
  return getParamType(obj).toLowerCase() === 'number';
};
/**
 * 判断对象是否字符串
 * @param {object} object 对象
 * @return {bool} 是/否
 */

export var isString = function isString(obj) {
  return getParamType(obj).toLowerCase() === 'string';
};
/**
 * 判断是否布尔值
 * @param {object} object 对象
 * @return {bool} 是/否
 */

export var isBoolean = function isBoolean(obj) {
  return getParamType(obj).toLowerCase() === 'boolean';
};
/**
     * 判断对象是否日期
     * @param {object} object 对象
     * @return {bool} 是/否
     */

export var isDate = function isDate(obj) {
  return getParamType(obj).toLowerCase() === 'date';
};
/**
 * 判断对象是否DOM元素
 * @param {object} obj DOM对象
 * @return {bool} 是/否
 */

export var isDom = function isDom(obj) {
  try {
    return obj && _typeof(obj) === 'object' && !isUndefined(obj.nodeType) && obj.nodeType == 1 && !isUndefined(obj.nodeName) && typeof obj.nodeName === 'string';
  } catch (e) {
    // console.log(e)
    return false;
  }
};
/**
 * 获取DOM对象的值
 * @param {object} obj DOM对象
 * @return {string} 取value或innerHTML
 */

export var getDomVal = function getDomVal(obj) {
  return obj.value || obj.innerHTML;
};
/**
 * 索引序列
 * @param {serial,function} 数组或对象集合
 * @return {undefined}
 */

export var forEach = function forEach(haystack, callback) {
  var i = 0;
  var length = haystack.length;
  var name;

  if (length !== undefined) {
    for (; i < length;) {
      // eslint-disable-next-line no-plusplus
      if (callback.call(haystack[i], i, haystack[i++]) === false) {
        break;
      }
    }
  } else {
    for (name in haystack) {
      callback.call(haystack[name], name, haystack[name]);
    }
  }
};
/**
 * 获取dom对象
 * @param {string|dom} dom的id或对象k
 * @return {dom}
 */

export var g = function g(obj) {
  return _typeof(obj) === 'object' ? obj : document.getElementById(obj);
};
export var compareVersions = function compareVersions(v1, v2) {
  var parts1 = v1.split('.').map(Number);
  var parts2 = v2.split('.').map(Number);

  for (var i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    var num1 = i < parts1.length ? parts1[i] : 0;
    var num2 = i < parts2.length ? parts2[i] : 0;
    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }

  return 0;
};